import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@env';

@Pipe({
  name: 'paymentMethodImage'
})
export class ImageUrlPipe implements PipeTransform {
  transform(fileName: string | undefined, isCryptoImage = false): string {
    if (!fileName) {
      return '';
    }

    let path = `${ environment.cdnPath }/payments/`;

    if (isCryptoImage) {
      path += 'crypto/';
    }

    return path + fileName;
  }
}
